import { put, call, takeEvery } from 'redux-saga/effects';
import { getTokenExpireDay } from 'utils/dateTimeUtils';
import { timezoneBE, TOKEN_LIVE_TIME_IN_DAYS } from '../../constant';
import * as actions from './actions';

const getCurrentDomain = () => {
  const { protocol, hostname } = window.location;
  const port = window.location.port ? `:${window.location.port}` : '';

  return `${protocol}//${hostname}${port}`;
};

export function* createToken(
  api,
  { interpreterId, resourceIdentifier, timeStamp },
  { thunk },
) {
  try {
    const dateValidUntil = getTokenExpireDay(
      timezoneBE,
      TOKEN_LIVE_TIME_IN_DAYS,
      'YYYY-MM-DD[T]HH:mm:ss[Z]',
    );
    const reqData = {
      ResourceNumber: interpreterId,
      ResourceIdentifier: resourceIdentifier,
      TimeStamp: timeStamp,
      DatetimeValidUntil: dateValidUntil,
    };
    const response = yield call([api, api.post], 'createToken', reqData);
    yield put(actions.transvoiceLoginSuccess(response.data, reqData, thunk));
  } catch (e) {
    yield put(
      actions.transvoiceLoginFailure(
        e,
        { interpreterId, resourceIdentifier, timeStamp },
        thunk,
      ),
    );
  }
}

export function* authenticateResourceUser(
  api,
  { email, passwordHash, isRefresh },
  { thunk },
) {
  try {
    const detail = yield call([api, api.post], 'resourceUserAuthenticate', {
      ResourceEmailAddress: email,
      PasswordHash: passwordHash,
    });
    yield put(
      actions.transvoiceResourceAuthenticateSuccess(
        detail,
        { email, passwordHash },
        thunk,
      ),
    );
  } catch (e) {
    if (!isRefresh) {
      yield put(
        actions.transvoiceLoginFailure(e, { email, passwordHash }, thunk),
      );
    } else {
      window.location.href = '/login';
    }
  }
}

export function* authenticateResourceUserUsingId(
  api,
  { email, interpreterId },
  { thunk },
) {
  try {
    const detail = yield call(
      [api, api.post],
      'resourceUserAuthenticateUsingId',
      {
        EmailAddress: email,
        ResourceNumber: interpreterId,
        Url: getCurrentDomain(),
      },
    );
    yield put(
      actions.transvoiceLoginSuccess(detail, { email, interpreterId }, thunk),
    );
  } catch (e) {
    yield put(
      actions.transvoiceLoginFailure(e, { email, interpreterId }, thunk),
    );
  }
}

export function* watchResourceLogin(api, { payload, meta }) {
  yield call(createToken, api, payload, meta);
}

export function* watchResourceAuthenticate(api, { payload, meta }) {
  yield call(authenticateResourceUser, api, payload, meta);
}

export function* watchResourceAuthenticateUsingId(api, { payload, meta }) {
  yield call(authenticateResourceUserUsingId, api, payload, meta);
}
// eslint-disable-next-line func-names
export default function* ({ api }) {
  yield takeEvery(
    actions.AUTHENTICATE_RESOURCE,
    watchResourceAuthenticate,
    api,
  );
  yield takeEvery(
    actions.AUTHENTICATE_RESOURCE_USING_ID,
    watchResourceAuthenticateUsingId,
    api,
  );
  yield takeEvery(actions.TRANSVOICE_LOGIN_REQUEST, watchResourceLogin, api);
}
